import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=65abb2a0&scoped=true&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abb2a0",
  null
  
)

export default component.exports